import { render, staticRenderFns } from "./orderCountBottom.vue?vue&type=template&id=20a9544e&scoped=true&"
import script from "./orderCountBottom.vue?vue&type=script&lang=js&"
export * from "./orderCountBottom.vue?vue&type=script&lang=js&"
import style0 from "./orderCountBottom.vue?vue&type=style&index=0&id=20a9544e&prod&lang=scss&scoped=true&"
import style1 from "./orderCountBottom.vue?vue&type=style&index=1&id=20a9544e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9544e",
  null
  
)

export default component.exports